import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export const ClockIcon = (props) => {
    const { stroke = "#639CD2", ...otherProps } = props;
    return (
        <SvgIcon width="24" height="24" viewBox="0 0 24 24" {...otherProps}>
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g>
                            <path
                                fillRule="nonzero"
                                d="M0 0H24V24H0z"
                                transform="translate(-96 -151) translate(84 139) translate(12 12)"
                            />
                            <g
                                stroke={stroke}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                transform="translate(-96 -151) translate(84 139) translate(12 12) translate(2 2)"
                            >
                                <circle cx="10" cy="10" r="10" />
                                <path d="M10 4L10 10 14 12" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};
